import React from "react";
import { Helmet } from "react-helmet";
import "./Toolkit.css";

const Toolkit = () => {
  return (
    <main className="toolkit-page">
      <Helmet>
        <title>Flow Assurance Toolkit | AKIA Flow Assurance</title>
        <meta
          name="description"
          content="AKIA Flow Assurance Toolkit for pressure-drop engineering calculations."
        />
        <link rel="canonical" href="https://akiaflowassurance.com/toolkit" />
      </Helmet>

      <iframe
        className="toolkit-app"
        src={`${process.env.PUBLIC_URL}/pressure-drop-app-v8.1/index.html`}
        title="AKIA Flow Assurance Toolkit"
        loading="eager"
      />
    </main>
  );
};

export default Toolkit;
